import React, { useState } from "react";

import { auth } from "../../firebase";
import { navigateToSignUp } from "../routing/router-utils";
import { helpText } from './registration-errors';
import { trackEvent } from '../analytics/tracking';
import PrimaryHeader from '../styleguide/PrimaryHeader';
import TextField from '@material-ui/core/TextField';
import SendResetEmailForm from '../resetPassword/SendResetEmailForm';

import styles from './Registration.module.css';
/* material UI styles */
import './MaterialUI.module.css';

const SignInProtectedRoutes = ({onSignIn}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);

  const [showPasswordReset, setShowPasswordReset] = React.useState(false);
 
  const signInWithEmailAndPasswordHandler = (event, email, password) => {
    event.preventDefault();
    
    // The Modal Login in the PageHeader is pre-router, so we'll use window.location
    const signInPath = window.location.pathname;
    
    auth.signInWithEmailAndPassword(email, password).then(function() {
      // Sign-in successful.
      trackEvent('login', `from_${signInPath}`);
      // Update routing, continue to protected route
      onSignIn();

    }).catch(error => {
      trackEvent('error_invalid_login', signInPath);
      setError(helpText['login']); // Invalid login or password
    });
 
  };
    
  const onChange = event => {
    const {id, value} = event.currentTarget;
    setError(false);
    if(id === 'loginEmail') {
      setEmail(value);
    } else if(id === 'loginPassword'){
      setPassword(value);
    }
  };

  return (
    <>    
      {/* toggle between sign in and forgot password */}
      { showPasswordReset
        ? <SendResetEmailForm handleCancel={() => setShowPasswordReset(false)} />
        : <div className={styles.modalForm}>
            <div className={`${styles.headerWrap} ${styles.nonModal}`}>
              <PrimaryHeader isCentered text="Sign In" />
            </div>

            { error !== null && 
              <div className={styles.formError}>{error}</div>
            }
            
            <form>
              <TextField id="loginEmail" value={email} label="Email" error={false} 
                type="email" variant="filled"  onChange={onChange} />
              <TextField id="loginPassword" value={password} label="Password" error={false}
                type="password" variant="filled" onChange={onChange} />  
                
              <div className={styles.loginForgotPassword}>
                <span onClick={() => setShowPasswordReset(true)} className={styles.forgotPasswordLink}>
                  Forgot your password?
                </span>
              </div>
      
              <button
                id="login" // for test 
                className={styles.formButton} 
                onClick = {(event) => {
                  signInWithEmailAndPasswordHandler(event, email, password);
                }}>
                LOG IN
              </button>
            </form>
              
            <div className={styles.twoCol}>
              <span className={styles.signInLink}>Don't have an account?</span>
              <span className={styles.formAlignRight}>
                <span className={`${styles.formButton} ${styles.formSignUpButton}`} 
                  onClick={navigateToSignUp}>
                  SIGN UP
                </span>
              </span>
            </div>
          </div>
      }  
    </>
  );  
};

export default SignInProtectedRoutes;